export default "__VITE_PUBLIC_ASSET__79fdce21__"